module.exports = __webpack_public_path__ + "images/logo-blue-transparent.svg";